





































































































































































import axios from 'axios';
import EventBus from '@/eventBus';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoMultiselect from '@/components/Molecules/co-multiselect/CoMultiSelect.vue';
import CoHeader from '@/components/Molecules/co-header/CoHeader.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoPaywall from '@/components/Organisms/co-paywall/CoPaywall.vue';

interface EventsCalendarSettings {
    spaceID: string;
    enabled: boolean;
    baseURL: string;
    username: string;
    password: string;
    authToken: string;
    allowedVisibilities: string[];
    defaultHiddenUpcoming: boolean;
    defaultSticky: boolean;
    defaultFeatured: boolean;
    defaultHidden: boolean;
}

export default {
    name: 'TheEventCalendarIntegration',
    components: {
        CoCard,
        CoHeader,
        CoText,
        CoInput,
        CoSwitch,
        CoButton,
        CoFormGroup,
        CoMultiselect,
        CoLoadingIndicator,
        CoPaywall,
    },
    data() {
        return {
            form: this.defaultSettings(),
            loading: false,
            saving: false,
            testing: false,
            visibilitySelection: [] as Array<{ Name: string; Value: string }>,
        };
    },
    created() {
        if (this.isFreePlan) {
            this.$nextTick(() => this.showPaywall());
            return;
        }
        this.fetchSettings();
    },
    computed: {
        isFreePlan() {
            const space = this.$store && this.$store.state && this.$store.state.space;
            return space && space.PlanSlug === 'free';
        },
    },
    methods: {
        defaultSettings(): EventsCalendarSettings {
            const space = this.$store && this.$store.state && this.$store.state.space;
            return {
                spaceID: (space && space.ID) || '',
                enabled: false,
                baseURL: '',
                username: '',
                password: '',
                authToken: '',
                allowedVisibilities: [],
                defaultHiddenUpcoming: false,
                defaultSticky: false,
                defaultFeatured: false,
                defaultHidden: false,
            };
        },
        showPaywall() {
            const paywall = this.$refs.paywall as { show: () => void } | undefined;
            if (paywall && typeof paywall.show === 'function') {
                paywall.show();
            }
        },
        visibilityOptions() {
            const defaults = [
                { Name: this.$t('labels.public'), Value: 'public' },
                { Name: this.$t('labels.community'), Value: 'community' },
            ];
            const existing = (this.form.allowedVisibilities || []).map((val) => ({
                Name: this.prettyVisibility(val),
                Value: val,
            }));
            const seen = new Set();
            return [...defaults, ...existing].filter((item) => {
                const key = String(item.Value);
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
        },
        prettyVisibility(val: string) {
            if (!val) return '';
            return val.charAt(0).toUpperCase() + val.slice(1);
        },
        syncVisibilitySelection() {
            this.visibilitySelection = (this.form.allowedVisibilities || []).map((val) => ({
                Name: this.prettyVisibility(val),
                Value: val,
            }));
        },
        normalizeSettingsPayload(payload: Record<string, unknown> | undefined): EventsCalendarSettings {
            const settings = (payload?.settings as Record<string, unknown>) || payload || {};
            return Object.assign(this.defaultSettings(), settings);
        },
        buildWrappedSettings() {
            const settings = {
                ...this.form,
                baseURL: this.form.baseURL?.trim() || '',
                username: this.form.username?.trim() || '',
                password: this.form.password || '',
                authToken: this.form.authToken?.trim() || '',
                spaceID: this.form.spaceID?.trim() || '',
            };
            return { settings };
        },
        updateAllowedVisibilities(items: Array<{ Name: string; Value: string }>) {
            this.visibilitySelection = items || [];
            this.form.allowedVisibilities = (items || [])
                .map((item) => (item.Value !== undefined ? String(item.Value) : item.Name))
                .filter(Boolean);
        },
        fetchSettings() {
            if (this.isFreePlan) return;

            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/integration/events-calendar/settings',
                withCredentials: true,
            })
                .then((response) => {
                    this.form = this.normalizeSettingsPayload(response?.data);
                    this.syncVisibilitySelection();
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.eventcalendarloadfailed'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        saveSettings() {
            if (this.isFreePlan) {
                this.showPaywall();
                return;
            }

            this.saving = true;
            axios({
                method: 'PUT',
                url: '/admin/integration/events-calendar/settings',
                data: this.buildWrappedSettings(),
                withCredentials: true,
            })
                .then(() => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.changessaved'),
                    });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('errors.failedToSaveChanges'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.saving = false;
                });
        },
        testConnection() {
            if (this.isFreePlan) {
                this.showPaywall();
                return;
            }

            this.testing = true;
            axios({
                method: 'POST',
                url: '/admin/integration/events-calendar/test-connection',
                data: this.buildWrappedSettings(),
                withCredentials: true,
            })
                .then((response) => {
                    const ok = response?.data?.ok;
                    const message =
                        response?.data?.message ||
                        (ok ? this.$t('messages.connectionSuccessful') : this.$t('messages.connectionFailed'));
                    EventBus.$emit(ok ? 'INFO' : 'ERROR', {
                        Message: message,
                    });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.connectionTestFailed'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.testing = false;
                });
        },
    },
};
